<template>
  <div class="water-counter__content">
    <div class="water-counter">
      <div class="water__drank">
        <h3>{{ $t("profile.home.drankWater") }}</h3>
        <div class="water__value">
          {{waterValue}} {{ $t("profile.home.ml") }}
        </div>
      </div>

      <div class="water__allowed">
        <h3>{{ $t("profile.home.dailyAllowance") }}</h3>
        <div class="water__value">
          <input type="number" v-model="allowedWater" min="0" max="10000" @input="handleInput"> {{ $t("profile.home.ml") }}
        </div>
      </div>
    </div>

    <div class="water__portions">
      <div v-for="(portion, i) in waterPortions" class="portion">
        <div class="portion__info">
          <img :src="`/media/inpulse-template-ac-new-a/profile/water/${i + 1}.png`" alt="glass of water" draggable="false">

          {{portion}} {{ $t("profile.home.ml") }}
        </div>

        <div class="portion__action" :class="{action_disabled: !isToday}" @click="() => isToday && addWater(portion)">
          <img src="/media/inpulse-template-ac-new-a/profile/water/plus.svg" alt="plus">
          {{ $t("profile.home.add") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "water-counter",

  props: ["date"],

  data() {
    return {
      waterValue: 0,
      allowedWater: 2000,
      waterPortions: [150, 250, 350, 500, 750, 1000],
      waterValueCache: null,
    }
  },

  watch: {
    date() {
      this.loadCache();
    },
  },

  mounted() {
    this.loadCache();
  },

  computed: {
    isToday() {
      return new Date(this.date).setHours(0, 0, 0, 0) === new Date(Date.now()).setHours(0, 0, 0, 0);
    },
  },

  methods: {
    handleInput() {
      if (this.allowedWater > 9999) {
        this.allowedWater = 9999;
      } else if (this.allowedWater < 0) {
        this.allowedWater = 0;
      }

      localStorage.setItem("allowed-water-value", this.allowedWater);
    },
    loadCache() {
      this.waterValueCache = localStorage.getItem("water-value");
      this.allowedWaterValueCache = localStorage.getItem("allowed-water-value");

      let currDate = new Date(this.date);
      currDate.setHours(0, 0, 0, 0);
      currDate = currDate.getTime();

      if (this.waterValueCache) {
        this.waterValueCache = JSON.parse(this.waterValueCache);
      }
      if (this.allowedWaterValueCache) {
        this.allowedWater = JSON.parse(this.allowedWaterValueCache);
      }

      if (this.waterValueCache) {
        if (this.waterValueCache[currDate]) {
          this.waterValue = this.waterValueCache[currDate];
        } else if (this.isToday) {
          this.setWaterValue();
        } else {
          this.waterValue = 0;
        }
      } else {
        this.waterValueCache = {};
        this.setWaterValue();
      }
    },
    addWater(portion) {
      this.setWaterValue(this.waterValue + portion);
    },
    setWaterValue(data) {
      let value = 0;

      if (data) {
        value = data;
      }

      let currDate = new Date(this.date);
      currDate.setHours(0, 0, 0, 0);
      currDate = currDate.getTime();

      this.waterValue = value;
      this.waterValueCache[currDate] = value;
      localStorage.setItem("water-value", JSON.stringify(this.waterValueCache));
    },
  }
}
</script>

<style lang="sass">
.water-counter__content
  .water-counter
    display: flex
    width: 100%
    justify-content: center
    margin-top: 12px
    margin-bottom: 20px

    .water__drank
      margin-right: 20px

    .water__drank,
    .water__allowed
      h3
        margin-bottom: 12px
        text-align: center
        color: rgba(42, 42, 42, 1)
        font-size: 18px
        line-height: 18px
        font-weight: 400

      .water__value
        display: flex
        align-items: center
        justify-content: center
        min-width: 140px
        padding: 14px
        color: rgba(42, 42, 42, 1)
        font-size: 22px
        line-height: 22px
        font-weight: 600
        text-align: center
        border: 1px solid rgba(240, 240, 240, 1)
        background: rgba(250, 250, 250, 1)
        border-radius: 8px

    .water__allowed
      input
        color: rgba(42, 42, 42, 1)
        font-size: 22px
        line-height: 22px
        font-weight: 600
        background: none
        border: none
        border-bottom: 1px solid
        -moz-appearance: textfield
        border-radius: 0
        outline: none
        padding: 0
        width: 4ch
        margin-right: 1ch

        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button
          -webkit-appearance: none
          margin: 0

      .water__value
        color: rgba(155, 155, 155, 1)

  .water__portions
    display: flex
    flex-wrap: wrap
    gap: 16px
    justify-content: center
    margin: 0 auto
    max-width: 472px

    .portion
      display: flex
      flex-direction: column
      align-items: center
      box-shadow: 1px 4px 8px 0px rgba(117, 117, 117, 0.1)
      background: #ffffff
      border-radius: 16px
      min-width: 140px
      padding: 8px 8px 11px

    .portion__action
      display: flex
      align-items: center
      justify-content: center
      border: 2px solid rgba(192, 60, 80, 1)
      background: #ffffff
      min-width: 100px
      min-height: 32px
      cursor: pointer
      border-radius: 40px
      color: rgba(192, 60, 80, 1)
      font-size: 18px
      line-height: 18px
      transition: .3s ease
      user-select: none

      &.action_disabled
        opacity: .3
        pointer-events: none

      &:hover
        background: rgba(192, 60, 80, 0.1)

      &:active
        background: rgba(192, 60, 80, 0.15)

    .portion__info
      display: flex
      align-items: center
      font-size: 18px
      line-height: 18px
      font-weight: 700
      text-align: left
      color: rgba(42, 42, 42, 1)
      margin-bottom: 9px

      img
        margin-right: 4px
</style>
